import axios from 'axios';
import { wrapAugmentationModelBF, wrapAugmentationModelFB } from '../../utils/augmentationModelWrapper';
import { getVuexPeristence } from '../index';

axios.interceptors.response.use((response) => { // intercept the global error
    return response;
}, function (error) {
    if (error.response.status === 401) {
        window.location.href = '/login';
        return;
    }
    return Promise.reject(error);
});

const loop = (arr, fn, busy, err, i = 0) => {
    const body = (ok, er) => {
        try {
            const r = fn(arr[i], i, arr);
            r && r.then ? r.then(ok).catch(er) : ok(r);
        } catch (e) {
            er(e);
        }
    };
    const next = (ok, er) => () => loop(arr, fn, ok, er, ++i);
    const run = (ok, er) => i < arr.length ? new Promise(body).then(next(ok, er)).catch(er) : ok();
    return busy ? run(busy, err) : new Promise(run);
};

export default {
    namespaced: true,
    state: {
        mode: '',
        experience: { name: '' },
        augmentations: [],
        defaultNewAugmentation: {
            name: '',
            images: [],
            action_type: '',
            data: {}
        },
        selectDeleteAugments: [],
        newAugmentation: {},
        selectSortDescription: getVuexPeristence('augmentations.selectSortDescription',
            'Tri par date de mise à jour'),
        orderSort: getVuexPeristence('augmentations.orderSort', false)
    },

    getters: {
        mode: (state) => state.mode,
        experience: (state) => state.experience,
        augmentations: (state) => state.augmentations,
        augmentationIsSelect: (state) => (token) => state.selectDeleteAugments.includes(token),
        currentExperienceToken: (state) => state.experience.token,
        currentOrganisationToken: (state) => state.experience.organisation
    },
    mutations: {
        SET_MODE_AUGMENTATION: (state, data) => {
            state.mode = data.mode;
            state.newAugmentation = state.defaultNewAugmentation;
            if (state.mode !== 'deleteValidate') {
                state.selectDeleteAugments = [];
            }
        },
        SET_EXPERIENCE: (state, data) => {
            state.experience = data;
        },
        SET_AUGMENTATIONS: (state, list) => {
            state.augmentations = list;
        },
        SET_NEW_AUGMENTATION: (state, data) => {
            state.newAugmentation = Object.assign({}, state.newAugmentation, data);
        },
        HANDLE_DELETE_AUGMENTATION: (state, data) => {
            if (!state.selectDeleteAugments.includes(data)) {
                state.selectDeleteAugments.push(data);
            } else {
                state.selectDeleteAugments = state.selectDeleteAugments.filter(function (element) {
                    return element !== data;
                });
            }
        },
        DELETE_AUGMENT_IN_STORE: (state, token) => {
            state.augmentations = state.augmentations.filter((augment) => {
                return augment._id !== token;
            });
        },
        ADD_AUGMENT_IN_STORE: (state, newAugment) => {
            state.augmentations.push(newAugment);
        },
        FROZEN_EXPERIENCE: (state, frozen) => {
            state.experience.frozen = frozen;
        },
        EDIT_EXPERIENCE_PARAMETERS: (state, data) => {
            state.experience.name = data.name;
            state.experience.description = data.description;
        },
        CLEAN_CURRENT_AUGMENTATION: (state) => {
            state.augmentations = [];
            state.experience = { name: '' };
        },
        SET_SELECT_SORT_DESCRIPTION: (state, data) => {
            state.selectSortDescription = data;
        },
        SET_ORDER_SORT: (state, data) => {
            state.orderSort = data;
        }
    },

    actions: {
        modeNewAugmentation: (localStore) => {
            localStore.commit('SET_MODE_AUGMENTATION', {
                mode: 'add'
            });
        },
        modeDeleteAugmentations: (localStore) => {
            localStore.commit('SET_MODE_AUGMENTATION', {
                mode: 'delete'
            });
        },
        modeResetAugmentations: (localStore) => {
            localStore.commit('SET_MODE_AUGMENTATION', {
                mode: ''
            });
        },
        modeFrozenExperience: (localStore) => {
            localStore.commit('SET_MODE_AUGMENTATION', {
                mode: 'frozen'
            });
        },
        validateDeleteAugmentations: (localStore) => {
            localStore.commit('SET_MODE_AUGMENTATION', {
                mode: 'deleteValidate'
            });
        },
        loadExperience: (localStore, token) => {
            return new Promise((resolve, reject) => {
                axios.get('/campaign/' + token).then((response) => {
                    localStore.commit('SET_EXPERIENCE', response.data);
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        loadAugmentations: (localStore) => {
            return new Promise((resolve, reject) => {
                axios.get('/campaign/' + localStore.state.experience.token + '/augmentations').then((response) => {
                    response.data.map(function (element) {
                        return wrapAugmentationModelBF(element);
                    });
                    localStore.commit('SET_AUGMENTATIONS', response.data);
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        handleDeleteAugmentation: (localStore, data) => {
            localStore.commit('HANDLE_DELETE_AUGMENTATION', data);
        },
        addAugmentation: (localStore) => {
            return new Promise((resolve, reject) => {
                axios.post('/campaign/' + localStore.state.experience.token + '/augmentations',
                    wrapAugmentationModelFB(localStore.state.newAugmentation)).then((response) => {
                    localStore.commit('ADD_AUGMENT_IN_STORE', response.data.augment);
                    resolve(response.data.augment._id);
                }, (err) => {
                    reject(err);
                });
            });
        },
        deleteAugments: (localStore) => {
            return new Promise((resolve, reject) => {
                loop(localStore.state.selectDeleteAugments, item => {
                    axios.delete('/campaign/' + localStore.state.experience.token + '/augmentations/' + item)
                        .then(() => {
                            localStore.commit('DELETE_AUGMENT_IN_STORE', item);
                        });
                }).then(() => resolve()).catch((err) => reject(err));
            });
        },
        frozenExperience: (localStore, data) => {
            return new Promise((resolve, reject) => {
                let value = data ? '' : 'un';
                axios.put('/' + value + 'freeze/' + localStore.getters.experience.token)
                    .then(() => {
                        localStore.commit('FROZEN_EXPERIENCE', data);
                        resolve();
                    }, (err) => {
                        reject(err);
                    });
            });
        },
        publishExperienceParameters: function (localStore, data) {
            return new Promise((resolve, reject) => {
                axios.put('/campaign/' + localStore.state.experience.token, {
                    name: data.name,
                    description: data.description
                }).then(() => {
                    localStore.commit('EDIT_EXPERIENCE_PARAMETERS', data);
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        cleanAugmentations: function (localStore) {
            localStore.commit('CLEAN_CURRENT_AUGMENTATION');
        }
    }
};
